/**
 * Artifact downloads on web: the twin of `artifact-download.ts`, same exports.
 *
 * The download link is minted per click (it expires after 15 minutes) with an
 * attachment disposition, so following it saves the file without leaving the
 * page. An anchor click rather than `window.open`, which popup blockers would
 * stop after the awaited mint.
 */
import type { ArtifactDownloadVariant } from '@tabbio/types';
import { artifactFileName } from '../components/artifacts/artifact-model';
import { mintDownloadUrl } from './artifacts-api';

export type ArtifactDownloadRequest = {
  artifactId: string;
  variant: ArtifactDownloadVariant;
  title: string;
};

export async function downloadArtifactFile({
  artifactId,
  variant,
  title,
}: ArtifactDownloadRequest): Promise<void> {
  const signed = await mintDownloadUrl(artifactId, variant);
  if (typeof document === 'undefined') return;
  const anchor = document.createElement('a');
  anchor.href = signed.url;
  anchor.rel = 'noopener noreferrer';
  // Ignored cross-origin, where the server's Content-Disposition names the
  // file; kept for same-origin storage in local development.
  anchor.download = artifactFileName(title, variant, signed.contentType);
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
